module.exports = __webpack_public_path__ + "img/Aelis4-logo-dark.1ce54e9e.png";